var clickpostForm = document.querySelector(".clickpost-edd__form");
var submitButton = document.querySelector(
  ".clickpost-edd__form .pincode-button"
);
window.isPincodeFetched = false;
var responseEddText = document.getElementById("response-edd-text").innerHTML;
var responseCodText = document.getElementById("response-cod-text").innerHTML;
var month = clickpostForm.querySelector('input[name="month"]').value;
var dateFormat = clickpostForm.querySelector('input[name="date_format"]').value;
var cutoffTime = clickpostForm.querySelector('input[name="cutoff_time"]')
  ? clickpostForm.querySelector('input[name="cutoff_time"]').value
  : "24";
const countdownElement = document.getElementById("countdown");
var ezedd = clickpostForm.querySelector('input[name="ezedd"]')
  ? clickpostForm.querySelector('input[name="ezedd"]').value
  : false;
var variantSKUMapping = clickpostForm.querySelector(
  'input[name="variant_sku_mapping"]'
).value;
var variantMetafieldsMapping = clickpostForm.querySelector(
  'input[name="variant_metafields_mapping"]'
).value;

const pairs = variantSKUMapping.split(",");
const metafieldsPairs = variantMetafieldsMapping.split(",");

const parsedMapping = {};
pairs.forEach((pair) => {
  const [variantId, sku] = pair.split(":");
  parsedMapping[variantId] = sku;
});

const metafieldsParsedMapping = {};
metafieldsPairs.forEach((pair) => {
  const [variantId, metafield] = pair.split(":");
  metafieldsParsedMapping[variantId] = metafield;
});

const now = new Date();
const targetHours = cutoffTime;
const targetTimeToday = new Date(
  now.getFullYear(),
  now.getMonth(),
  now.getDate(),
  targetHours
).getTime();
if (countdownElement) {
  const countdownInterval = setInterval(() => {
    const currentTime = new Date().getTime();
    const timeRemaining = targetTimeToday - currentTime;
    if (timeRemaining > 0) {
      const hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      )
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000)
        .toString()
        .padStart(2, "0");
      countdownElement.innerHTML = `Order within <span style='color:red'>${hours}:${minutes}:${seconds}</span>`;
    } else {
      countdownElement.innerHTML = "00:00:00";
      clearInterval(countdownInterval); // Stop the countdown
    }
  }, 1000);
}
var monthMap = [];
if (month == "false") {
  monthMap = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
} else {
  monthMap = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
}
const nth = function (d) {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
submitButton.addEventListener("click", (event) => {
  event.preventDefault();
  fetchEdd();
});
var inputElementEnter = clickpostForm.querySelector(
  'input[name="drop_pincode"]'
);
inputElementEnter.addEventListener("keyup", function (e) {
  if (e.key === "Enter" || e.keyCode === 13) {
    event.preventDefault();
    fetchEdd();
  }
});
const fetchEdd = (pincodeValue) => {
  var submitButton = document.querySelector(
    ".clickpost-edd__form .pincode-button"
  );
  submitButton.classList.toggle("button--loading");
  submitButton.disabled = true;
  submitButton.querySelector("span").textContent = "";
  document.querySelector(".response-container").classList.remove("tw-hidden");
  var cod = false;
  var responseFail = document.getElementById("response-error");
  var responseSuccess = document.getElementById("response-success");
  responseFail.style.display = "none";
  responseSuccess.style.display = "none";
  document.getElementById("response-hide").style.display = "none";
  let dropPincode =
    pincodeValue ||
    clickpostForm.querySelector('input[name="drop_pincode"]').value;
  var productId = clickpostForm.querySelector('input[name="product_id"]').value;

  if (dropPincode.length != 6 || !/^\d+$/.test(dropPincode)) {
    responseFail.style.color = "red";
    responseFail.innerHTML = document.getElementById(
      "response-invalid-text"
    ).innerHTML;
    responseSuccess.style.display = "none";
    responseFail.style.display = "block";
       if (document.querySelector(".add-to-cart-btn")) {
       document
        .querySelector(".add-to-cart-btn")
        .setAttribute("disabled", "true");
    }
    submitButton.classList.toggle("button--loading");
    submitButton.disabled = false;
    submitButton.querySelector("span").textContent = "check";
    if (document.querySelector(".DeliveryPinIfavailable")) {
      document.querySelector(".DeliveryPinIfavailable").innerHTML = "";
    }
    document.querySelector(".pincode-failure").classList.add("hidden");
    return false;
  } else {
    if (document.querySelector(".add-to-cart-btn")) {
      document.querySelector(".add-to-cart-btn").removeAttribute("disabled");
    }
  }

  var pickupPincode = clickpostForm.querySelector(
    'input[name="pickup_pincode"]'
  ).value;
  var method = clickpostForm.querySelector('input[name="method"]').value;
  var standardEdd = clickpostForm.querySelector(
    'input[name="standard_edd"]'
  ).value;
  var productEdd = clickpostForm.querySelector('input[name="product_edd"]')
    ? clickpostForm.querySelector('input[name="product_edd"]').value
    : 0;
  var collectionEdd = clickpostForm.querySelector(
    'input[name="collection_edd"]'
  )
    ? clickpostForm.querySelector('input[name="collection_edd"]').value
    : 0;
  var dateRange = clickpostForm.querySelector('input[name="date_range"]').value;
  var vendorEdd = clickpostForm.querySelector('input[name="vendor_edd"]')
    ? clickpostForm.querySelector('input[name="vendor_edd"]').value
    : 0;
  var logic = clickpostForm.querySelector('input[name="logic"]')
    ? clickpostForm.querySelector('input[name="logic"]').value
    : false;
  sessionStorage.setItem("drop_pincode", dropPincode);
  const productErrorMessage = document.querySelector(".ProductErrorMessage");

  if (productErrorMessage) {
    productErrorMessage.style.display = "none";
    productErrorMessage.innerHTML = "";
  }

  var virtualBundleVariantId = document.querySelector(
    ".virtual-bundle-product-atc"
  );
  var selectedElement = document.querySelector(
    ".variant-options-radio.selected-variant"
  );

  var selectedProductAsVariant = document.querySelector(
    'input[name="product-as-variants"]:checked'
  );

  if (selectedElement || virtualBundleVariantId || selectedProductAsVariant) {
    var variantId = "";
    if (virtualBundleVariantId != null) {
      var getVariantId = virtualBundleVariantId
        .getAttribute("data-virtual-bundling-variant-ids")
        .split(",")[0];
      var variantId = getVariantId;
    } else if (selectedElement != null) {
      var variantId = selectedElement.dataset.variantId;
      var variantSKU = selectedElement.dataset.variantSku;
    } else {
      var variantId = selectedProductAsVariant.dataset.variantId;
      var variantSKU = selectedProductAsVariant.dataset.variantSku;
    }

    cod = true;

    const eddData = {
      dropPincode: dropPincode,
      variantId: variantId,
      sku: parsedMapping[variantId],
      metafield:
        metafieldsParsedMapping[variantId] != ""
          ? metafieldsParsedMapping[variantId]
          : 0,
    };

    fetch("/apps/clickpost-edd-proxy/ez-edd", {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify([eddData]),
    })
      .then((response) => response.json())
      .then((data) => {
        responseFail.style.display = "none";
        responseSuccess.style.display = "block";

        if (data.res === true) {
          window.isPincodeFetched = true;
          var finalEdd = "";

          var dateCurrent = new Date();
          var ez_sla_max = new Date(data.data.max);
          const sla_max = Math.ceil(
            (ez_sla_max.getTime() - dateCurrent.getTime()) /
              (1000 * 60 * 60 * 24)
          );
          var ez_sla_min = new Date(data.data.min);
          const sla_min = Math.ceil(
            (ez_sla_min.getTime() - dateCurrent.getTime()) /
              (1000 * 60 * 60 * 24)
          );
          const errorElement = document.querySelector(
            ".clickpost-edd__container #response-error"
          );

          // var date = Date.now();
          // var dateCurrent = new Date(date);
          var afterCutoff = false;
          // if (method != 'multi') {
          //   afterCutoff = (dateCurrent.getHours() + 1) > parseInt(cutoffTime) ? true : false;
          // }
          var max =
            sla_max +
            parseInt(standardEdd) +
            parseInt(productEdd) +
            parseInt(collectionEdd) +
            parseInt(vendorEdd);
          if (afterCutoff) max = max + 1;
          max = new Date(dateCurrent.getTime() + parseInt(max * 86400000));
          var maxDate = max.getDate();
          if (dateRange == "true") {
            var min =
              sla_min +
              parseInt(standardEdd) +
              parseInt(productEdd) +
              parseInt(collectionEdd) +
              parseInt(vendorEdd);
            if (afterCutoff) min = min + 1;
            min = new Date(dateCurrent.getTime() + parseInt(min * 86400000));
            var minDate = min.getDate();
            if (min.getMonth() == max.getMonth())
              finalEdd =
                `<span class="successful-response">` +
                minDate +
                "<sup>" +
                nth(minDate) +
                "</sup>" +
                ` and ` +
                maxDate +
                "<sup>" +
                nth(maxDate) +
                "</sup>" +
                " " +
                monthMap[max.getMonth()] +
                `</span>`;
            else
              finalEdd =
                `<span class="successful-response">` +
                minDate +
                "<sup>" +
                nth(minDate) +
                "</sup>" +
                " " +
                monthMap[min.getMonth()] +
                ` and ` +
                maxDate +
                "<sup>" +
                nth(maxDate) +
                "</sup>" +
                " " +
                monthMap[max.getMonth()] +
                `</span>`;
          } else {
            finalEdd =
              `<span class="successful-response">` +
              maxDate +
              "<sup>" +
              nth(maxDate) +
              "</sup>" +
              " " +
              monthMap[max.getMonth()] +
              `</span>`;
          }
          const responseEDD = document.getElementById("response-edd");
          responseEDD.innerHTML = responseEddText + " " + finalEdd;
          cod = cod
            ? `<span class="successful-response">available</span>`
            : '<span style="color:red">not available</span>';
          document.getElementById("response-cod").innerHTML =
            responseCodText + " " + cod;

          if (errorElement) {
            errorElement.style.display = "none";
            errorElement.innerHTML = "";
          }

          // setting NDD atrribute
          const today = new Date();
          const currentDay = today.getDate();
          const productAtc =
            document.querySelector(".product-atc") ||
            document.querySelector(".gift-card-atc") ||
            document.querySelector("#customizer-button");

          // Check if the difference between currentDay and minDate is 1
          if (Math.abs(currentDay - minDate) === 1) {
            if (productAtc) {
              productAtc.setAttribute("data-NDD-available", true);
              productAtc.classList.remove("is-disabled");
            }
          } else {
            if (productAtc) {
              productAtc.setAttribute("data-NDD-available", false);
              productAtc.classList.remove("is-disabled");
            }
          }

          if (document.querySelector(".DeliveryPinIfavailable")) {
            document.querySelector(".DeliveryPinIfavailable").innerHTML =
              dropPincode;
          }
          submitButton.classList.toggle("button--loading");
          submitButton.disabled = false;
          submitButton.querySelector("span").textContent = "check";
          if (countdownElement && method == "single") {
            const nowClickpost = new Date();
            const targetHours = cutoffTime;
            const targetTimeToday = new Date(
              nowClickpost.getFullYear(),
              nowClickpost.getMonth(),
              nowClickpost.getDate(),
              targetHours
            ).getTime();
            const targetTimeTomorrow = targetTimeToday + 24 * 60 * 60 * 1000;
            const timeToday = targetTimeToday - nowClickpost.getTime();

            if (timeToday > 0) {
              const countdownInterval = setInterval(() => {
                const currentTime = new Date().getTime();
                const timeRemaining = targetTimeToday - currentTime;
                if (timeRemaining > 0) {
                  const hours = Math.floor(
                    (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                  )
                    .toString()
                    .padStart(2, "0");
                  const minutes = Math.floor(
                    (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
                  )
                    .toString()
                    .padStart(2, "0");
                  const seconds = Math.floor(
                    (timeRemaining % (1000 * 60)) / 1000
                  )
                    .toString()
                    .padStart(2, "0");
                  countdownElement.innerHTML = `Order within <span style='color:red'>${hours}:${minutes}:${seconds}</span>`;
                } else {
                  countdownElement.innerHTML = "00:00:00";
                  clearInterval(countdownInterval); // Stop the countdown
                }
              }, 1000);
            } else {
              const countdownIntervalTomorrow = setInterval(() => {
                const currentTime = new Date().getTime();
                const timeRemainingTomorrow = targetTimeTomorrow - currentTime;
                if (timeRemainingTomorrow > 0) {
                  const hours = Math.floor(
                    (timeRemainingTomorrow % (1000 * 60 * 60 * 24)) /
                      (1000 * 60 * 60)
                  )
                    .toString()
                    .padStart(2, "0");
                  const minutes = Math.floor(
                    (timeRemainingTomorrow % (1000 * 60 * 60)) / (1000 * 60)
                  )
                    .toString()
                    .padStart(2, "0");
                  const seconds = Math.floor(
                    (timeRemainingTomorrow % (1000 * 60)) / 1000
                  )
                    .toString()
                    .padStart(2, "0");
                  countdownElement.innerHTML = `Order within <span style='color:red'>${hours}:${minutes}:${seconds}</span>`;
                } else {
                  countdownElement.innerHTML = "00:00:00";
                  clearInterval(countdownIntervalTomorrow); // Stop the countdown
                }
              }, 1000);
            }
            countdownElement.style.display = "block";
          }
        } else if (data.res === false) {
          document
            .querySelector(".add-to-cart-btn")
            .setAttribute("disabled", "true");
          window.isPincodeFetched = false;
          const resErrorMsg = data.data.error;
          const errorElement = document.querySelector(
            ".clickpost-edd__container #response-error"
          );
          const successElement = document.querySelector(
            ".clickpost-edd__container #response-success"
          );
          const productAtc =
            document.querySelector(".product-atc") ||
            document.querySelector(".gift-card-atc") ||
            document.querySelector("#customizer-button");

          // setting false attribute when res. false
          if (productAtc) {
            productAtc.setAttribute("data-NDD-available", false);
            productAtc.classList.add("is-disabled");
          }

          if (errorElement) {
            errorElement.style.display = "flex";
            errorElement.innerHTML = resErrorMsg;
          }

          if (successElement) {
            successElement.style.display = "none";
          }

          if (document.querySelector(".DeliveryPinIfavailable")) {
            document.querySelector(".DeliveryPinIfavailable").innerHTML =
              dropPincode;
          }

          sessionStorage.removeItem("drop_pincode");
          submitButton.classList.toggle("button--loading");
          submitButton.disabled = false;
          submitButton.querySelector("span").textContent = "check";
        }
      })
      .catch((error) => {
        console.log(error);
        window.isPincodeFetched = false;
        submitButton.classList.toggle("button--loading");
        submitButton.disabled = false;
        submitButton.querySelector("span").textContent = "check";
        responseFail.style.display = "block";
        responseFail.innerHTML = `Unable to retrieve estimated delivery date.`;
        const productAtc =
          document.querySelector(".product-atc") ||
          document.querySelector(".gift-card-atc") ||
          document.querySelector("#customizer-button");

        document
          .querySelector(".add-to-cart-btn")
          .setAttribute("disabled", "true");

        // setting false attribute when res. false
        if (productAtc) {
          productAtc.setAttribute("data-NDD-available", false);
          productAtc.classList.add("is-disabled");
        }

        if (document.querySelector(".DeliveryPinIfavailable")) {
          document.querySelector(".DeliveryPinIfavailable").innerHTML = "";
        }
        sessionStorage.removeItem("drop_pincode");
      });
  } else {
    if (document.querySelector(".DeliveryPinIfavailable")) {
      document.querySelector(".DeliveryPinIfavailable").innerHTML = "";
    }

    if (clickpostForm.querySelector('input[name="drop_pincode"]').value != "") {
      clickpostForm.querySelector('input[name="drop_pincode"]').value = "";
    }

    if (submitButton && submitButton.classList.contains("button--loading")) {
      sessionStorage.removeItem("drop_pincode");
      submitButton.classList.toggle("button--loading");
      submitButton.disabled = false;
      submitButton.querySelector("span").textContent = "check";
      window.isPincodeFetched = false;
    }
  }
};

document.addEventListener("DOMContentLoaded", (event) => {
  const dropPincode = sessionStorage.getItem("drop_pincode");
  if (dropPincode) {
    clickpostForm.querySelector('input[name="drop_pincode"]').value =
      dropPincode;
    let selectedProductAsVariant = document.querySelector(
      'input[name="product-as-variants"]:checked'
    );
     let fallbackVariant;
    if (!selectedProductAsVariant) {
      fallbackVariant = document.querySelector(
        "marmeto-variants input:checked"
      );
    }
    if (selectedProductAsVariant) {
      if (selectedProductAsVariant.dataset.available == "true") {
        fetchEdd();
      }
    } else {
      if (fallbackVariant.dataset.available == "true") {
        fetchEdd();
      }
    }
  }
});

window.globalFetchEdd = fetchEdd;

document
  .querySelector("input[name=drop_pincode]")
  .addEventListener("input", (e) => {
    document.querySelector(".response-container").classList.add("tw-hidden");
    window.isPincodeFetched = false;
    document.querySelector(".pincode-failure").classList.add("hidden");
  });
